import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { Info, List, MinusCircle, Plus, Repeat } from "react-feather";

export const MenuOptions = ({ params, Actions }) => {
  const { idcredito, costo_retiro_gps, fecha_ren_gps, fecha_ren_seguro, fecha_fin_credito } = params.data;

  const date_ren_gps = new Date(fecha_ren_gps);
  const date_ren_seguro = new Date(fecha_ren_seguro);
  const date_fin_credito = new Date(fecha_fin_credito);

  const disable = !(costo_retiro_gps>0)
  const disableGPS = !(date_fin_credito>date_ren_gps)
  const disableSeguro = !(date_fin_credito>date_ren_seguro)

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const {handleClickInsuranceRenewal, handleClickGPSRenewal} = Actions

  return (
    <>
      <Button 
        startIcon = { <List/>}
        variant='contained'
        size='small' 
        color='success'
        sx={{ marginRight: '8px' }}
        onClick={handleMenuOpen} 
        style={ { width: 150 } }
        > 
        Gestiones
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        // sx={{
        //   position: 'absolute',
        //   zIndex: 2000, // Asegura visibilidad
        // }}
        // MenuListProps={{
        //   'aria-labelledby': 'basic-button',
        // }}
      >
        {/* <MenuItem 
        
          disabled={disable}
          onClick={()=>{
            handleClickGPSRemovalFee(idcredito)
            handleMenuClose()
          }}
        >
          <ListItemIcon> <MinusCircle color="black"/> </ListItemIcon>
          <ListItemText primary="Exoneracion de retiro GPS" />
        </MenuItem> */}

        <MenuItem 
          disabled={disableSeguro}
          onClick={() => {
            handleClickInsuranceRenewal(idcredito)
            // handleMenuClose()
          }}
        >
          <ListItemIcon> <Repeat color="black"/> </ListItemIcon>
          <ListItemText primary="Renovacion de seguros" />
        </MenuItem>
        
        <MenuItem 
          disabled={disableGPS}
          onClick={()=>{
            console.log(disableGPS,fecha_ren_gps,fecha_fin_credito );
            
            handleClickGPSRenewal(idcredito)
            // handleMenuClose()
          }}
        >
          <ListItemIcon> <Repeat color="black"/> </ListItemIcon>
          <ListItemText primary="Renovacion de GPS" />
        </MenuItem>
      </Menu>
    </>
  );
};
